import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer__wrapper">
        <h2 className="footer__app__name">Cryptoverse</h2>
        <h5> © Pradip Khamkar</h5>
      </div>
    </div>
  );
};

export default Footer;
